export default "__VITE_ASSET__YB8OniUl__"